const APP_NAME = "Flux Orders";

const EXACT_ROUTES: Record<string, string> = {
  "/dashboard": "Dashboard",
  "/route-planner": "Route Schedules",
  "/route-planner/calendar": "Route Calendar",
  "/route-planner/new": "New Route",
  "/my-account": "My Account",
  "/account/company-settings": "Company Settings",
  "/forms": "Forms",
  "/customers": "Manage Customers",
  "/customers/new": "New Customer",
  "/customer-groups": "Manage Groups",
  "/customer-groups/new": "New Customer Group",
  "/products": "Manage Products",
  "/products/imports": "Product Imports",
  "/products/create": "New Product",
  "/primary-categories": "Primary Categories",
  "/primary-categories/new": "New Primary Category",
  "/sub-categories": "Sub Categories",
  "/sub-categories/new": "New Sub Category",
  "/create-order": "Create Order",
  "/orders": "Manage Orders",
  "/expenses": "Manage Expenses",
  "/loblaws-skus": "Loblaws Skus",
  "/shippings": "Shipping History",
  "/create-shipping": "Create Shipping",
  "/cart": "Cart",
  "/users": "Users",
  "/users/new": "New User",
  "/tax-rates": "Tax Rates",
  "/suppliers": "Suppliers",
  "/warehouses": "Warehouses",
  "/quickbooks-login": "Quickbooks",
  "/quickbooks/callback": "Quickbooks",
  "/login": "Login",
  "/forgot-password": "Forgot Password",
  "/reset-password": "Reset Password",
};

const PARAM_ROUTES = [
  { prefix: "/route-planner/", title: "Route Details" },
  { prefix: "/forms/", title: "Form Details" },
  { prefix: "/customers/", title: "Customer Details" },
  { prefix: "/customer-groups/", title: "Customer Group Details" },
  { prefix: "/products/", title: "Product Details" },
  { prefix: "/primary-categories/", title: "Category Details" },
  { prefix: "/sub-categories/", title: "Sub Category Details" },
  { prefix: "/orders/", title: "Order Details" },
  { prefix: "/shippings/", title: "Shipping Details" },
  { prefix: "/users/", title: "User Details" },
];

export function getPageTitle(pathname: string): string {
  const exact = EXACT_ROUTES[pathname];
  if (exact) {
    return `${exact} | ${APP_NAME}`;
  }

  for (const { prefix, title } of PARAM_ROUTES) {
    if (pathname.startsWith(prefix)) {
      return `${title} | ${APP_NAME}`;
    }
  }

  return APP_NAME;
}
